export default __webpack_public_path__ + "static/media/youtube_logo.14baa330.svg";